import React from 'react';
import axios from 'axios';
import { Form, Input, Select, Button, Card, Popconfirm, notification } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import CardListForm from 'components/CardListForm';
import OtherSelect from 'components/OtherSelect';
import formItemLayout from 'components/Portal/formItemLayout';

class DietaryRestrictionForm extends React.Component {
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (err) return console.error(err);
			this.props.onSave(this.props.restriction.index, values);
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		let {
			AssignId, Comments, rmkCombo1, rmkCombo2, rmkString1, index,
			id, comments, substance, type, result, saved
		} = this.props.restriction;
		if (!AssignId) AssignId = id;
		if (!Comments) Comments = comments;
		if (!rmkCombo1) rmkCombo1 = (substance)? substance.key: '';
		if (!rmkCombo2) rmkCombo2 = (type)? type.key: '';
		if (!rmkString1) rmkString1 = result;
		const disabled = this.props.sectionDisabled || saved;
		return (
			<Card>
				<Form onSubmit={this.handleSubmit}>
					{disabled && !this.props.sectionDisabled &&
						<Form.Item style={{textAlign:'right'}}>
							<Button icon="edit" onClick={this.props.onEdit.bind(this, this.props.restriction.index)}>Edit</Button>
						</Form.Item>
					}
					{!disabled &&
						<Form.Item style={{textAlign:'right'}}>
							<Popconfirm title="Are you sure?" okText="Remove" cancelText="Cancel"
								onConfirm={this.props.onRemove.bind(this, this.props.restriction.index)}>
								<Button type="danger" size="large" icon="delete">Remove</Button>
							</Popconfirm>
							<Button type="primary" htmlType="submit" icon="save">Save</Button>
						</Form.Item>
					}
					<Form.Item label="Dietary restriction" {...formItemLayout}>
						{getFieldDecorator('substance', {
							initialValue: {key: rmkCombo1},
							rules: [{required: true}]
						})(
							<Select labelInValue placeholder="Vegan, Gluten-free, etc." disabled={disabled}>
								{[
									{key: '32904', label: 'Dairy Free'},
									{key: '32905', label: 'Gluten Free'},
									{key: '32906', label: 'Kosher'},
									{key: '32907', label: 'Specific Food/Other'},
									{key: '32903', label: 'Vegan'},
									{key: '32902', label: 'Vegetarian'}
								].map(option => {
									return <Select.Option key={option.key}>{option.label}</Select.Option>
								})}
							</Select>
						)}
					</Form.Item>
					<Form.Item label="Type of restriction"
						help={<span>A food <strong>allergy</strong> causes an immune system reaction that affects numerous organs in the body and can be life-threatening.<br />Food <strong>sensitivity/intolerance</strong> symptoms, though uncomfortable, are less serious and usually isolated to digestive problems (can't trigger anaphylaxis.)</span>}
						{...formItemLayout}>
						{getFieldDecorator('type', {
							initialValue: {key: rmkCombo2},
							rules: [{required: true}]
						})(
							<Select labelInValue disabled={disabled}>
								{[
									{key: '21729', label: 'Allergy'},
									{key: '21727', label: 'Preference'},
									{key: '21728', label: 'Sensitivity/Intolerance'}
								].map(option => {
									return <Select.Option key={option.key}>{option.label}</Select.Option>
								})}
							</Select>
						)}
					</Form.Item>
					<Form.Item label="Reaction and exposure required" {...formItemLayout}>
						{getFieldDecorator('result', {
							initialValue: rmkString1,
							rules: [{max: 50, message: 'Reaction too long (50 characters max)'}]
						})(
							<Input placeholder={(disabled)? '' : 'stomach upset after eating a serving, hives after exposure to trace amounts due to cross-contamination, etc.'} disabled={disabled} />
						)}
					</Form.Item>
					<Form.Item label="Requested Accommodations"
						help={"200 Character Max. This is not a confirmation of accommodation. Accommodating every unique restriction for every participant is not possible given the unique challenges of working with many different providers in developing nations."}
						{...formItemLayout}>
						{getFieldDecorator('comments', {
							initialValue: Comments,
							rules: [{max: 200, message: 'Requested Accomdations too long (200 characters max)'}]
						})(
							<Input type="textarea" disabled={disabled} />
						)}
					</Form.Item>
					<Form.Item>
						{getFieldDecorator('id', {
							initialValue: AssignId
						})(
							<Input type="hidden" />
						)}
					</Form.Item>
					<Form.Item>
						{getFieldDecorator('index', {
							initialValue: index
						})(
							<Input type="hidden" />
						)}
					</Form.Item>
				</Form>
			</Card>
		);
	}
}
const WrappedDietaryRestrictionForm = Form.create()(DietaryRestrictionForm);

class DietaryRestrictions extends React.Component {
	state = {
		restrictions: [],
		restrictionsSet: false
	}
	handleChange = (s) => {
		this.setState(s);
	}
	handleSave = (restriction, s, index) => {
		this.props.isLoading();
		let submitRestriction = Object.assign({}, restriction);
		submitRestriction.substanceCode = submitRestriction.substance.key;
		submitRestriction.substanceString = submitRestriction.substance.label;
		submitRestriction.typeCode = submitRestriction.type.key;
		submitRestriction.typeString = submitRestriction.type.label;
		axios({
			method: (submitRestriction.id) ? 'put' : 'post',
			url: apiPath+'/remark/27',
			data: submitRestriction,
			withCredentials: true
		}).then(result => {
			if (!submitRestriction.id) s.restrictions[index].AssignId = result.data.FolioList.Folio.AssignId;
			this.props.isDoneLoading();
			this.setState(s);
		}).catch(error => {
			this.props.isDoneLoading();
			this.props.handleAxiosSaveError(error);
		});
	}
	handleRemove = (restriction, s) => {
		if (!restriction.AssignId) return this.setState(s);
		this.props.isLoading();
		axios.delete(apiPath+'/remark/'+restriction.AssignId, {withCredentials: true})
			.then(result => {
				this.props.isDoneLoading();
				this.setState(s);
			}).catch(error => {
				this.props.isDoneLoading();
				notification.error({
					message: error.message,
					duration: 0
				});
				console.error(error);
			});
	}
	getRestrictionsFromProps = (props) => {
		if (!this.state.restrictionsSet && props.remarksLoaded) {
			this.setState({
				restrictions: props.remarks
					.filter(remark => remark.Code === 'DIETRES')
					.map(restriction => { restriction.saved = true; return restriction })
			});
		}
	}
	componentDidMount() {
		this.props.refreshRemarks().then(result => {this.getRestrictionsFromProps(this.props);});
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'health/dietary');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'health/dietary');
			if (redirect) return redirect;
		}

		let i = -1;
		return (
			<div className="withSpacing">
				<p>
					Please note: The information you submitted in your medical history form is confidential and not shared with the Field Office.
					If you would like the Field Office (including partner organizations and Trip Liaisons) to know about a dietary restriction, please indicate so here.
					Due to the unique nature of the SAS program, not all accommodations and requests can be guaranteed.
					SAS will support participants in communicating, advocating and planning for their needs, but cannot guarantee complete compliance.
					<br /><br />
					Concerned participants should contact SAS to discuss a plan for success: <a href="mailto:Field@isevoyages.org">Field@isevoyages.org</a>
				</p>
				<CardListForm title="Dietary Restriction" thing="restrictions" restrictions={this.state.restrictions} disabled={disabled}
					onChange={this.handleChange} onSave={this.handleSave} onRemove={this.handleRemove}>
					{this.state.restrictions.map(restriction => {
						i++;
						restriction.index = i;
						let key = i;
						if (restriction.id) key += '_'+restriction.id;
						return (
							<WrappedDietaryRestrictionForm key={key} restriction={restriction} sectionDisabled={disabled} />
						);
					})}
				</CardListForm>
			</div>
		);
	}
}

export default withSpin(DietaryRestrictions);



// WEBPACK FOOTER //
// ./portal-components/Portal/Health/DietaryRestrictions.jsx